import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"

import { API_URL } from "../reusable/urls"

import reply from '../reducers/reply'

import Questions from './Questions'
import QuestionsSwedish from './QuestionsSwedish'
import QuestionsSpanish from "./QuestionsSpanish"
import QRcode from "./QRcode"
import QRcodeWelcomeMessageEN from "./QRcodeWelcomeMessageEN"
import QRcodeWelcomeMessageSV from "./QRcodeWelcomeMessageSV"
import QRcodeWelcomeMessageES from "./QRcodeWelcomeMessageES"

import "./main.css"

const Main = () => {
    const accessToken = useSelector(store => store.user.accessToken)
    const role = useSelector((store) => store.user.role)
    const username = useSelector(store => store.user.username)
    const language = useSelector(store => store.user.language)
    const isSubmitted = useSelector(store => store.reply.isSubmitted)
    const registered = useSelector(store => store.user.registered)

    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        if (!accessToken) {
            navigate('/login')
        }
    }, [accessToken, navigate])

    useEffect(() => {
        if (accessToken && role === 'admin') {
            navigate('/summary')
            const options = {
                method: 'GET',
                headers: {
                    Authorization: accessToken
                }
            }
        
            fetch(API_URL('reply'), options)
                .then(res => res.json())
                .then(data => dispatch(reply.actions.setPatientData(data)))

        }
    }, [accessToken, role, navigate, dispatch])

    // get single user data
    useEffect(() => {
        if (accessToken && role === 'patient' && registered === true ) {
            navigate('/patient-summary')
            const options = {
                method: 'POST',
                headers: {
                    Authorization: accessToken,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ username })
            }
        
            fetch(API_URL('already-reply'), options)
                .then(res => res.json())
                .then(data => {
                    dispatch(reply.actions.setPatientData(data))
                    dispatch(reply.actions.setCreatedAt(data[0].createdAt))
                })

        }
    }, [accessToken, role, username, registered, navigate, dispatch])

// Enter language-specific questionnaire
    if (isSubmitted === false && role === 'patient' && language === 'en') {
        return (
          <div>
              <Questions />
          </div>
        )
    }

    else if (isSubmitted === false && role === 'patient' && language === 'sw') {
        return (
            <div>
                <QuestionsSwedish />
            </div>
        )

    }else if (isSubmitted === false && role === 'patient' && language === 'es') {
        return (
            <div>
                <QuestionsSpanish />
            </div>
        )
    
// Enter language- specific Thank You message
    } else if (isSubmitted === true && role === 'patient' && language === 'en') {
            return (
                <div className="thank-you">
                    <h1 className="main-title">
                        Thank you for your valuable help, it is greatly appreciated!
                    </h1>
                    <QRcodeWelcomeMessageEN />
                    <QRcode />
                </div>
            )
    } else if (isSubmitted === true && role === 'patient' && language === 'sw') {
            return (
                <div className="thank-you">
                    <h1 className="main-title">
                        Tack för din värdefulla hjälp, vi uppskattar det väldigt mycket!
                    </h1>
                    <QRcodeWelcomeMessageSV />
                    <QRcode />
                </div>
            )
    } else if (isSubmitted === true && role === 'patient' && language === 'es') {
        return (
            <div className="thank-you">
                <h1 className="main-title">
                    Gracias por su valiosa ayuda, es muy apreciado!
                </h1>
                <QRcodeWelcomeMessageES />
                <QRcode />
            </div>
        )
    }
}

export default Main